/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import React, {useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {PaleteUlaziModel} from '../../models/PaleteUlaziModel'
import {fetchPaleteUlazi, savePaleteUlazi, updatePaleteUlazi} from '../../api/PaleteUlazi'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import notifyToast from '../../components/Toast/Toast'
import {ToastContainer} from 'react-toastify'
import TitleComponent from '../../components/TitleComponent/TitleComponent'
import LoadingComponent from '../../components/LoadingComponent/LoadingComponent'
import {ArtikliOperacijeModel} from "../../models/ArtikliOperacije";
import {fetchArtikliOperacije, saveArtikliOperacije, updateArtikliOperacije} from "../../api/artikliOperacije";
import ArtikliGalanterija from "../../components/ArtikliGalanterija/ArtikliGalanterija";
import SredstvaDropdown from "../../components/SredstvaDropdown/SredstvaDropdown";

const ArtikliOperacijeDetails:React.FC = () => {
    const {id} = useParams()
    const IdFromURL = Number(id)

    const [loading, setLoading] = useState(true)

    const initialValues = {
        idArtikla: undefined,
        idMasine: undefined,
        naziv: undefined,
        norma: undefined,
        normaMinuta: undefined,
        brojOperacija: undefined,
        status: 1,
        napomena: undefined
    }
    const [initialData, setInitialData] = useState<Partial<ArtikliOperacijeModel>>(initialValues)

    useEffect(() => {
        if (IdFromURL) {
            fetchArtikliOperacije(IdFromURL)
                .then((data) => {
                    setInitialData(data)
                    formik.resetForm({values: data}) // <-- reset formik state here
                })
                .finally(() => setLoading(false))
        } else {
            setLoading(false)
        }
    }, [IdFromURL])

    const validationSchema = Yup.object({
        idArtikla: Yup.string().required('Required'),
        idMasine: Yup.string().required('Required'),
        naziv: Yup.string().required('Required'),
        norma: Yup.number().required('Required'),
        normaMinuta: Yup.number().required('Required'),
        brojOperacija: Yup.number().required('Required'),
        status: Yup.number().oneOf([0, 1]).required('Required')
    })

    const formik = useFormik({
        initialValues: initialData,
        validationSchema: validationSchema,
        onSubmit: async (values, {setStatus, setSubmitting}) => {
            setLoading(true)
            try {
                let response
                if (IdFromURL) {
                    response = await updateArtikliOperacije(IdFromURL, values)
                } else {
                    response = await saveArtikliOperacije(values)
                }

                if (response.error === 0) {
                    notifyToast(true, response.message)
                } else {
                    notifyToast(false, response.message || 'An unexpected error occurred.')
                }
            } catch (error: any) {
                console.error('Error: ', error)
                notifyToast(false, error.response.data.message)
                setStatus(error)
            } finally {
                setLoading(false)
                setSubmitting(false)
            }
        },
    })
    return (
        <div className='row'>
            <ToastContainer />
            <div className='card mb-5 mb-xl-10 col-6'>
                <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                >
                    <div className='card-title m-0'>
                        <TitleComponent name='' />
                    </div>
                </div>
                <div id='kt_account_profile_details' className='collapse show'>
                    {loading ? (
                        <LoadingComponent />
                    ) : (
                        <form onSubmit={formik.handleSubmit} noValidate>
                            <div className='card-body border-top p-9 row'>
                                {/* Artikal */}
                                <div className='col-6 mb-6'>
                                    <div className='col'>
                                        <label className='col-auto col-form-label required fw-bold fs-6'>Artikal</label>
                                        <div className='col-auto fv-row'>
                                            <ArtikliGalanterija
                                                value={formik.values.idArtikla}
                                                onChange={(name, value) => formik.setFieldValue('idArtikla', value)}
                                                errors={formik.errors.idArtikla}
                                                touched={formik.touched.idArtikla}
                                                selectName='idArtikla'
                                            />
                                        </div>
                                    </div>
                                </div>
                                {/* Naziv operacije */}
                                <div className='col-6 mb-6'>
                                    <label className='col-auto required col-form-label fw-bold fs-6'>Naziv operacije</label>

                                    <div className='col-auto fv-row'>
                                        <input
                                            type='text'
                                            placeholder='Naziv operacije'
                                            {...formik.getFieldProps('naziv')}
                                            className={clsx(
                                                'form-control form-control-lg form-control-solid',
                                                {
                                                    'is-invalid':
                                                        formik.touched.naziv &&
                                                        formik.errors.naziv,
                                                },
                                                {
                                                    'is-valid':
                                                        formik.touched.naziv &&
                                                        !formik.errors.naziv,
                                                }
                                            )}
                                        />
                                        {formik.touched.naziv && formik.errors.naziv && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.naziv}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Norma */}
                                <div className='col-6 mb-6'>
                                    <label className='col-auto col-form-label required fw-bold fs-6'>
                                        Norma [komada]
                                    </label>

                                    <div className='col-auto fv-row'>
                                        <input
                                            type='number'
                                            placeholder='Norma'
                                            {...formik.getFieldProps('norma')}
                                            className={clsx(
                                                'form-control form-control-lg form-control-solid',
                                                {'is-invalid': formik.touched.norma && formik.errors.norma},
                                                {
                                                    'is-valid': formik.touched.norma && !formik.errors.norma,
                                                }
                                            )}
                                        />
                                        {formik.touched.norma && formik.errors.norma && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.norma}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Norma min */}
                                <div className='col-6 mb-6'>
                                    <label className='col-auto col-form-label required fw-bold fs-6'>
                                        Norma [minuta]
                                    </label>

                                    <div className='col-auto fv-row'>
                                        <input
                                            type='number'
                                            placeholder='normaMinuta'
                                            {...formik.getFieldProps('normaMinuta')}
                                            className={clsx(
                                                'form-control form-control-lg form-control-solid',
                                                {'is-invalid': formik.touched.normaMinuta && formik.errors.normaMinuta},
                                                {
                                                    'is-valid': formik.touched.normaMinuta && !formik.errors.normaMinuta,
                                                }
                                            )}
                                        />
                                        {formik.touched.normaMinuta && formik.errors.normaMinuta && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.normaMinuta}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Broj operacija */}
                                <div className='col-6 mb-6'>
                                    <label className='col-auto col-form-label required fw-bold fs-6'>
                                        Broj operacija
                                    </label>

                                    <div className='col-auto fv-row'>
                                        <input
                                            type='number'
                                            placeholder='Broj operacija'
                                            {...formik.getFieldProps('brojOperacija')}
                                            className={clsx(
                                                'form-control form-control-lg form-control-solid',
                                                {'is-invalid': formik.touched.brojOperacija && formik.errors.brojOperacija},
                                                {
                                                    'is-valid': formik.touched.brojOperacija && !formik.errors.brojOperacija,
                                                }
                                            )}
                                        />
                                        {formik.touched.brojOperacija && formik.errors.brojOperacija && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.brojOperacija}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-6 mb-6'>
                                    <label className='col-auto col-form-label required fw-bold fs-6'>
                                        Sredstvo (Mašina)
                                    </label>
                                    <div className='col-auto fv-row'>
                                        <SredstvaDropdown
                                            value={formik.values.idMasine}
                                            onChange={(name, value) => formik.setFieldValue('idMasine', value)}
                                            errors={formik.errors.idMasine}
                                            touched={formik.touched.idMasine}
                                            selectName='IdSredstva'
                                        />
                                    </div>
                                </div>


                                {/* Status */}
                                <div className='col-6 mb-6'>
                                    <label className='col-auto col-form-label required fw-bold fs-6'>Status</label>

                                    <div className='col-auto fv-row'>
                                        <select
                                            value={formik.values.status ?? 1}
                                            onChange={(event) => formik.setFieldValue('status', Number(event.target.value))}
                                            onBlur={() => formik.setFieldTouched('status', true)}
                                            className={clsx(
                                                'form-select form-select-lg form-select-solid',
                                                {'is-invalid': formik.touched.status && formik.errors.status},
                                                {'is-valid': formik.touched.status && !formik.errors.status}
                                            )}
                                        >
                                            <option value={1}>Aktivan</option>
                                            <option value={0}>Neaktivan</option>
                                        </select>
                                        {formik.touched.status && formik.errors.status && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.status}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Napomena */}
                                <div className='col mb-6'>
                                    <label className='col-auto col-form-label fw-bold fs-6'>Napomena</label>

                                    <div className='col-auto fv-row'>
                    <textarea
                        placeholder='Napomena'
                        {...formik.getFieldProps('napomena')}
                        className={clsx(
                            'form-control form-control-lg form-control-solid',
                            {
                                'is-invalid':
                                    formik.touched.napomena && formik.errors.napomena,
                            },
                            {
                                'is-valid':
                                    formik.touched.napomena && !formik.errors.napomena,
                            }
                        )}
                    />
                                        {formik.touched.napomena && formik.errors.napomena && (
                                            <div className='fv-plugins-message-container'>
                                                <div className='fv-help-block'>{formik.errors.napomena}</div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='card-footer d-flex justify-content-end py-6 px-9'>
                                <button
                                    type='submit'
                                    className='btn btn-primary'
                                    disabled={loading || formik.isSubmitting || !formik.isValid}
                                >
                                    {!loading && 'Potvrdi'}
                                    {loading && (
                                        <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...{' '}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                                    )}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    )
}
export default ArtikliOperacijeDetails;
